export default __webpack_public_path__ + "static/media/svg-decorator-blob-3.5c569394.svg";